import { Route } from "@angular/router";

export const blankRoutes: Route[] = [
    {
        path: "",
        data: { layout: "blank" },
        children: [
            {
                path: "login",
                title: `로그인`,
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("../pages/auth/sign-in/sign-in.page"),
                    },
                    {
                        path: "form",
                        loadComponent: () =>
                            import("../pages/auth/login/login.page"),
                    },
                    {
                        path: ":provider",
                        loadComponent: () =>
                            import("../pages/auth/sign-in/sign-in.page"),
                    },
                ],
            },
            {
                path: "sign-up",
                title: `회원가입`,
                loadComponent: () =>
                    import("../pages/auth/sign-up/sign-up.page"),
            },
            {
                path: "find-email",
                title: `이메일 찾기`,
                loadComponent: () =>
                    import("../pages/auth/find-email/find-email.page"),
            },
            {
                path: "find-password",
                title: `비밀번호 찾기`,
                loadComponent: () =>
                    import("../pages/auth/find-password/find-password.page"),
            },
            {
                path: "term",
                title: `이용약관`,
                children: [
                    {
                        path: ":value",
                        loadComponent: () =>
                            import("../pages/auth/term/term.page"),
                    },
                ],
            },
            {
                path: "schedule-log/pdf",
                loadComponent: () =>
                    import("../pages/document/pages/schedule-log/pdf/schedule-log-pdf-template/schedule-log-pdf-template.page"),
            },
            {
                path: "document-box/pdf",
                loadComponent: () =>
                    import("../pages/document/pages/document-box/document-box-pdf/document-box-pdf.page"),
            },
            {
                path: "print-document/:documentId",
                loadComponent: () =>
                    import("../pages/document/pages/fix-document/fix-document-content/print-document/print-document.page"),
            },
            {
                path: "counseling/:counselingId",
                loadComponent: () =>
                    import("../pages/counseling-form/counseling-form"),
            },
        ],
    },
];
